import React from 'react';

export default function BlogFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{
      borderTop: 'none',
      background: '#2E5AAC',
      marginTop: '80px',
      color: 'white'
    }}>
      <div style={{
        maxWidth: 'var(--page-max)',
        margin: '0 auto',
        padding: '48px var(--page-pad) 32px'
      }}>
        {/* Footer Content */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '40px',
          marginBottom: '40px'
        }}>
          {/* Brand Column */}
          <div>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '16px'
            }}>
              <picture>
                <source
                  srcSet={`${process.env.PUBLIC_URL}/Vballstat-Logo-64.webp`}
                  type="image/webp"
                />
                <img
                  src={`${process.env.PUBLIC_URL}/Vballstat-Logo-64.png`}
                  alt="VBall Stats"
                  width="32"
                  height="32"
                  style={{
                    height: '32px',
                    width: 'auto',
                    filter: 'brightness(0) invert(1)'
                  }}
                />
              </picture>
              <span style={{ fontWeight: '700', fontSize: '16px', color: 'white' }}>VBall Stats</span>
            </div>
            <p style={{
              fontSize: '14px',
              color: 'rgba(255, 255, 255, 0.8)',
              lineHeight: '1.6',
              margin: 0
            }}>
              Track your volleyball performance and improve your game.
            </p>
          </div>

          {/* Product Links */}
          <div>
            <h4 style={{
              fontSize: '14px',
              fontWeight: '600',
              marginBottom: '16px',
              color: 'white'
            }}>
              Product
            </h4>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: '12px'
            }}>
              <li><a href="/" style={linkStyle}>Home</a></li>
              <li><a href="/help" style={linkStyle}>Help Center</a></li>
              <li><a href="/free-stat-sheets.html" style={linkStyle}>Free Stat Sheets</a></li>
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 style={{
              fontSize: '14px',
              fontWeight: '600',
              marginBottom: '16px',
              color: 'white'
            }}>
              Company
            </h4>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: '12px'
            }}>
              <li><a href="/about" style={linkStyle}>About</a></li>
              <li><a href="/contact-us" style={linkStyle}>Contact</a></li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 style={{
              fontSize: '14px',
              fontWeight: '600',
              marginBottom: '16px',
              color: 'white'
            }}>
              Legal
            </h4>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: '12px'
            }}>
              <li><a href="/privacy" style={linkStyle}>Privacy Policy</a></li>
              <li><a href="/changelog" style={linkStyle}>Changelog</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
          paddingTop: '24px',
          borderTop: '1px solid rgba(255, 255, 255, 0.2)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '16px'
        }}>
          <p style={{
            fontSize: '14px',
            color: 'rgba(255, 255, 255, 0.8)',
            margin: 0
          }}>
            © {currentYear} VBall Stats. All rights reserved.
          </p>
          <div style={{
            display: 'flex',
            gap: '16px'
          }}>
            {/* Add social media icons here if needed */}
          </div>
        </div>
      </div>
    </footer>
  );
}

const linkStyle = {
  fontSize: '14px',
  color: 'rgba(255, 255, 255, 0.8)',
  textDecoration: 'none',
  transition: 'color 0.2s'
};
